/** The fields a bill's display name reads. Structural, so a resolved GraphQL row passes through unadapted. */
export interface IBillDisplayNameSource {
  providerName: string;
  merchant?: { name: string } | null;
  financialAccount?: { name: string } | null;
}

/**
 * What to call a bill on any surface that names one.
 *
 * A card statement is the one bill shape with no merchant and always an
 * account, and its `providerName` is the issuer's string rather than the
 * household's — so the account sits between the two. `providerName` stays last
 * for a bill that arrived as a document: a real biller, and no account.
 *
 * One home rather than one per surface, because a chip and the page a click
 * opens disagreeing about a bill's name is the defect, and a comment on each
 * asking them to match cannot prevent it.
 */
export function billDisplayName(bill: IBillDisplayNameSource): string {
  return bill.merchant?.name ?? bill.financialAccount?.name ?? bill.providerName;
}
